// Learning resources listed on /resources. Add new entries here.
export interface IResource {
  title: string;
  description: string;
  href: string;
  source: string;
  specialization?: string;
  topics: string[];
}

export const resources: IResource[] = [
  {
    title: "Digital Design",
    description:
      "Course site with lecture recordings, weekly content, FPGA labs and design examples, from getting started with Docker for ASIC and FPGA work to a CPU in 40 lines of SystemVerilog.",
    href: "https://abapages.com/digital-design/index.html",
    source: "abapages.com · UC San Diego",
    specialization: "Build Your Own CPU",
    topics: ["SystemVerilog", "FPGA labs", "Lecture recordings"],
  },
  {
    title: "Physical Design with Open-Source Tools",
    description:
      "Back-end ASIC implementation from a synthesized netlist to GDSII: floorplanning, power planning, placement, clock tree synthesis, routing, timing closure and sign-off, with Yosys, OpenROAD, LibreLane and KLayout in IHP's open 130 nm PDK.",
    href: "https://www.skillsurf.org/physical-design/",
    source: "Skill Surf",
    specialization: "Build Your Own CPU",
    topics: ["Physical design", "OpenROAD", "Hands-on labs"],
  },
  {
    title: "The Art of Analog IC Design",
    description:
      "An open-source course in analog CMOS IC design, from the transistor to tape-out. Every circuit is designed, simulated and laid out with free tools in two open 130 nm processes, IHP SG13G2 and SkyWater SKY130.",
    href: "https://www.skillsurf.org/art_of_aicd/",
    source: "Skill Surf",
    specialization: "Art of IC Design",
    topics: ["Analog IC design", "SG13G2 & SKY130", "Hands-on labs"],
  },
  {
    title: "Introduction to Generative AI Workshop",
    description:
      "Slides and step-by-step notebooks covering attention and transformers, LLMs, building nanoGPT from a bigram model up, and image generation.",
    href: "https://www.skillsurf.org/introduction_genAI/intro.html",
    source: "Skill Surf",
    specialization: "Artificial Intelligence",
    topics: ["Transformers", "LLMs", "nanoGPT"],
  },
];
